export default {"src":"/_next/static/media/sauna.e76d942c.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};